import { Model } from '../store/types/booking';
import { MapActions, MapState } from '../store/types/map';
import { useStoreActions, useStoreState } from './store';

export const useBookingActions: MapActions<Model> = (mapActions) => useStoreActions((actions) => mapActions(actions.bookings));
export const useBookingState: MapState<Model> = (mapState) => useStoreState((state) => mapState(state.bookings));
